import auth from './auth'
import user from './user'
import content from './content'
import customer from './customer'
import statics from './statics'
import responsible from './responsible'
import inspection from './inspection'
import periodicCheck from './periodic-check'
import media from './media'
import company from './company'
import element from './element'
import license from './license'
import invitation from './invitation'
import contact from './contact'
import notification from './notification'
import enargas from './enargas'
import supportTasks from './support-tasks'

const services = {
  auth,
  user,
  content,
  customer,
  statics,
  responsible,
  inspection,
  periodicCheck,
  media,
  company,
  element,
  license,
  invitation,
  contact,
  notification,
  enargas,
  supportTasks
}

export default services
